import { useAuth } from './useAuth'

/**
 * Hook for role-based access control in components.
 * Reads role from the AuthProvider, which takes it from the Engine server (GET /api/me).
 *
 * Usage:
 *   const { role, isAdmin, isOperator, isViewer, hasRole } = useRole()
 *   if (isAdmin) { ... }
 *   if (hasRole('admin', 'operator')) { ... }
 */
export function useRole() {
  const { role } = useAuth()

  return {
    role,
    isAdmin: role === 'admin',
    isOperator: role === 'operator',
    isViewer: role === 'viewer',
    /** Check if current role is one of the allowed roles */
    hasRole: (...allowedRoles) => allowedRoles.includes(role),
  }
}
